import { render, staticRenderFns } from "./payment-confirmation.vue?vue&type=template&id=c03d4a46&scoped=true"
import script from "./payment-confirmation.vue?vue&type=script&lang=js"
export * from "./payment-confirmation.vue?vue&type=script&lang=js"
import style0 from "./payment-confirmation.vue?vue&type=style&index=0&id=c03d4a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03d4a46",
  null
  
)

export default component.exports